import { Group, Image, Text, UnstyledButton } from "@mantine/core";

import { useMosaicChat } from "modules/chat/components/MosaicChat/useMosaicChat";

import mosaicLogo from "modules/core/assets/img/mosaic.png";

import classes from "./styles.module.css";

const MosaicButton = () => {
  const { openChat } = useMosaicChat();

  return (
    <UnstyledButton
      onClick={() => openChat("mosaic")}
      className={classes.button}
    >
      <Group justify="center">
        <Group gap="xs">
          <Image
            src={mosaicLogo}
            alt="Mosaic"
            className={classes.image}
            fit="contain"
          />

          <Text fz="xs" c="yellow.4" fw={700}>
            Ask Mosaic
          </Text>
        </Group>
      </Group>
    </UnstyledButton>
  );
};

export default MosaicButton;
